import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SnelleBouwRenovatie() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="26704" id="jouw-digitale-toekomst-start-hier" className="dark bg-background text-foreground relative w-full min-h-[85vh] pt-20 flex items-center overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[#0a0a0a]/80 backdrop-blur-[2px] z-10" />
        <div className="w-full h-full bg-cover bg-center bg-no-repeat bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1589767/img/modern_interior_dining.png)] opacity-40" />
      </div>

      {}
      <div ref={ref} className={`relative z-20 container mx-auto px-6 md:px-12 lg:px-20 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="max-w-3xl text-left">
          <h1 className="text-transparent bg-clip-text bg-gradient-to-r from-primary via-primary to-secondary text-5xl md:text-[72px] font-bold leading-[1.1] mb-4 font-sans tracking-tight">
            Jouw Digitale Toekomst Start Hier
          </h1>
          
          <p className="text-secondary text-sm md:text-xs font-bold uppercase tracking-[0.2em] mb-6 font-sans">
            PREMIUM DIGITAAL BUREAU
          </p>
          
          <p className="text-muted-foreground text-base md:text-xl font-normal leading-relaxed mb-10 max-w-2xl font-sans">
            Wij ontwerpen krachtige websites die jouw visie vertalen naar een modern digitaal platform met optimale prestaties en een unieke merkidentiteit.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4">
            <Button asChild className="bg-gradient-to-r from-primary to-secondary text-white hover:opacity-90 rounded-lg h-12 px-8 text-base font-bold border-none shadow-[0_0_20px_rgba(139,92,246,0.3)] animate-pulse">
              <Link to="/ContactPage">
                Start Project
              </Link>
            </Button>
            
            <Button asChild className="bg-white/5 text-white hover:bg-white/10 rounded-lg h-12 px-8 text-base font-bold border border-white/10 backdrop-blur-md shadow-none">
              <Link to="/OurMethodPage">
                Bekijk Werk
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}